import { render, staticRenderFns } from "./whatsAppDialogue.vue?vue&type=template&id=46364420&scoped=true&"
import script from "./whatsAppDialogue.vue?vue&type=script&lang=ts&"
export * from "./whatsAppDialogue.vue?vue&type=script&lang=ts&"
import style0 from "./whatsAppDialogue.vue?vue&type=style&index=0&id=46364420&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46364420",
  null
  
)

export default component.exports